import { render } from "./App.vue?vue&type=template&id=24a55fe4&ts=true"
import script from "./App?vue&type=script&lang=ts&external"
export * from "./App?vue&type=script&lang=ts&external"

import "./App.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__